import { usePrevious } from '@calendly/hooks'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { SelectedSectionsActionsContext, SelectedSectionsStateContext } from './context'

const defaultSelectedSections = []

export const SelectedSectionsProvider = ({ children, resetOnChangeOf, initiallySelectedSections = defaultSelectedSections }) => {
  const [selectedSections, setSelectedSections] = useState(initiallySelectedSections)

  const previousResetOnChangeOf = usePrevious(resetOnChangeOf)
  useEffect(() => {
    if (!previousResetOnChangeOf || previousResetOnChangeOf === resetOnChangeOf) return

    setSelectedSections(defaultSelectedSections)
  }, [previousResetOnChangeOf, resetOnChangeOf])

  const selectSection = useCallback((section) => (
    setSelectedSections((prev) => [section, ...prev])
  ), [setSelectedSections])

  const swapCurrentSection = useCallback((section) => (
    setSelectedSections((prev) => [section, ...prev.slice(1)])
  ), [setSelectedSections])

  const closeCurrentSection = useCallback(() => (
    setSelectedSections((prev) => prev.slice(1))
  ), [setSelectedSections])

  const resetSelectedSections = useCallback(() => (
    setSelectedSections(defaultSelectedSections)
  ), [setSelectedSections])

  const state = useMemo(() => ({
    selectedSections
  }), [selectedSections])

  const actions = useMemo(() => ({
    selectSection, swapCurrentSection, closeCurrentSection, resetSelectedSections
  }), [selectSection, swapCurrentSection, closeCurrentSection, resetSelectedSections])

  return (
    <SelectedSectionsStateContext.Provider value={state}>
      <SelectedSectionsActionsContext.Provider value={actions}>
        {children}
      </SelectedSectionsActionsContext.Provider>
    </SelectedSectionsStateContext.Provider>
  )
}
